export const SPEEDS = [0.75, 0.9, 1, 1.1, 1.25, 1.5, 2];
